export default __webpack_public_path__ + "static/media/02C.962c31f6.png";